import { FrEventDetailsTab, FrEventDetailsTabConfig } from './types';
import { globalAttributes } from '../common/global-attributes';
import FrEventInfoTab from './components/tabs/fr-event-info-tab';
import FrNarrativeTab from './components/tabs/fr-narrative-tab';
import FrRelatedDataTab from './components/tabs/fr-related-data-tab';
import FrEventLogTab from './components/tabs/fr-event-log-tab';
import FrDexTab from './components/tabs/fr-dex-tab';
import FrMergedEventsTab from './components/tabs/fr-merged-events-tab';
import { FrAttachmentsTab } from './components/tabs/fr-attachments-tab';

export enum FR_EVENT_DETAILS_TABS {
    EVENT_INFO = 'EVENT_INFO',
    NARRATIVE = 'NARRATIVE',
    RELATED_DATA = 'RELATED_DATA',
    MEDIA_ATTACHMENTS = 'MEDIA_ATTACHMENTS',
    EVENT_LOG = 'EVENT_LOG',
    DEX = 'DEX',
    MERGED_EVENTS = 'MERGED_EVENTS',
}

export const DEFAULT_EVENT_DETAILS_TAB = FR_EVENT_DETAILS_TABS.NARRATIVE;

export const EVENT_DETAILS_TAB_CONFIG: FrEventDetailsTabConfig[] = [
    {
        name: 'Event Info',
        type: 'EVENT_INFO',
        icon: 'CADEvent',
        component: FrEventInfoTab,
    },
    { name: 'Narrative', type: 'NARRATIVE', icon: 'ListViewAlt', component: FrNarrativeTab },
    { name: 'Related Data', type: 'RELATED_DATA', icon: 'Document', component: FrRelatedDataTab },
    {
        name: 'Attachments',
        type: 'MEDIA_ATTACHMENTS',
        icon: 'Paperclip',
        component: FrAttachmentsTab,
        checkEnabled: (enabledFeatures) => enabledFeatures.mediaAttachmentsEnabled,
    },
    { name: 'Event Log', type: 'EVENT_LOG', icon: 'History', component: FrEventLogTab },
    {
        name: 'DEx Activity',
        type: 'DEX',
        icon: 'Dex',
        checkEnabled: (enabledFeatures, eventMetadata) =>
            enabledFeatures.dataExchangeEventPanelTab &&
            eventMetadata?.agencyTypeGlobalAttrId === globalAttributes.agencyTypeGlobal.POLICE,
        component: FrDexTab,
    },
    { name: 'Merged Events', type: 'MERGED_EVENTS', icon: 'Merge', component: FrMergedEventsTab },
];

export const FR_TAB_COMPONENTS: Record<
    FrEventDetailsTab,
    FrEventDetailsTabConfig['component']
> = Object.fromEntries(
    EVENT_DETAILS_TAB_CONFIG.map((tabConfig) => [tabConfig.type, tabConfig.component])
) as Record<FrEventDetailsTab, FrEventDetailsTabConfig['component']>;
